import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ChevronRight, ChevronLeft } from "lucide-react";
import "./css/NetworkingSessions.css";

const NetworkingSessions = () => {
  return (
    <section className="networking-sessions-section">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} md={12}>
            <div className="networking-content">
              <h2 className="title">Progress Tracking</h2>
              <ul className="features-list">
                <li>
                  <span className="feature-icon">✓</span>
                  Track completed activities, including courses, mentorship
                  sessions, and skill-building exercises.
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  Analyze assessment scores and skill growth to identify
                  strengths and areas for improvement.
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  Achieve milestones and earn automated badges to celebrate
                  progress and maintain motivation.
                </li>
                <li>
                  <span className="feature-icon">✓</span>
                  Adapt your career roadmap based on evolving skills, interests,
                  and AI-driven insights.
                </li>
              </ul>
            </div>
          </Col>
          <Col lg={6} md={12}>
            <div className="networking-image">
              <img
                src="./images/test_tube_graph.png"
                alt="Progress Tracker"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default NetworkingSessions;
